<div id="confirmation-dialog" class="main" role="alertdialog" aria-modal="true"
    aria-labelledby="confirmation-dialog-title" aria-describedby="confirmation-dialog-message">
    <div id="confirmation-dialog-title" class="title">{{ confirmationDialogService.title$ | async }}</div>
    <div id="confirmation-dialog-message" class="message">{{ confirmationDialogService.message$ | async }}</div>
    <div class="actions">
        <button type="button" *ngFor="let option of (confirmationDialogService.options$ | async )" class="button"
            (click)="submitResponse(option)">{{ option }}</button>
    </div>
</div>
